import '.ao{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.bj{position:absolute;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.j6{right:-4px;}.ssr-plugin'
import '.ez{width:1.5rem;}.ssr-plugin'
import '.f0{height:1.5rem;}.ssr-plugin'
import '.ai{border-radius:1.25rem;}.ssr-plugin'
import '.j7{background-color:var(--brand-primary);}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  isUploadPreview = false,
  size = 'small',
  onDelete,
  onCancelDelete,
}: {
  src: string
  isUploadPreview?: boolean
  size?: 'small' | 'large'
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="ao a aq t"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        ignoreResize={isUploadPreview}
        style={{
          width: size === 'small' ? '5.625rem' : '9.325rem',
          height: size === 'small' ? '5.625rem' : '9.325rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--palette-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a aq t bj bn j6 ez f0 ai j7 a1"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--palette-white)" />
    </div>
  )
}
